import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Router } from '@reach/router';
import { navigate } from 'gatsby';

import TrainingDetail from 'dpages/training-detail';

const TrainingRedirect = ({ location }) => {
  useEffect(() => {
    if (location.search.length > 0)
      navigate(`/trainings/course-content/${location.search.split('id=')[1]}`);
    else navigate('/trainings/');
  }, []);

  return <>Redirecting...</>;
};

TrainingRedirect.propTypes = {
  location: PropTypes.object,
};

const Training = () => (
  <Router>
    <TrainingRedirect path="/trainings/course-content/" />
    <TrainingDetail path="/trainings/course-content/:trainingId" />
  </Router>
);

export default Training;
